module.exports = __webpack_public_path__ + "img/RH_logo.c05e3220.png";